'use client';
import React, { useState } from 'react';
import { Phone, Mail, Globe, MapPin, Copy, Check } from 'lucide-react';
import { toast } from 'sonner';

const FacebookIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
  </svg>
);

const TwitterIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6 2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4-.9-4.2 4-6.6 7-3.8 1.1 0 3-1.2 3-1.2z" />
  </svg>
);

const InstagramIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
    <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
  </svg>
);

export default function BusinessContact() {
  const [copiedPhone, setCopiedPhone] = useState(false);

  const handleCopyPhone = () => {
    setCopiedPhone(true);
    toast?.success('Phone number copied to clipboard');
    setTimeout(() => setCopiedPhone(false), 2000);
  };

  return (
    <div className="card-surface p-5">
      <h2 className="font-bold text-base text-foreground mb-4">Contact Details</h2>
      <div className="space-y-3">
        <div className="flex items-center justify-between group">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 bg-primary/10 rounded flex items-center justify-center shrink-0">
              <Phone size={14} className="text-primary" />
            </div>
            <div>
              <div className="text-xs text-muted-foreground">Phone</div>
              <a href="tel:01284756234" className="text-sm font-semibold text-foreground hover:text-primary transition-colors">
                01284 756 234
              </a>
            </div>
          </div>
          <button
            onClick={handleCopyPhone}
            className="text-muted-foreground hover:text-primary transition-colors p-1.5 rounded hover:bg-muted"
            aria-label="Copy phone number"
          >
            {copiedPhone ? <Check size={14} className="text-positive" /> : <Copy size={14} />}
          </button>
        </div>

        <div className="flex items-center gap-3">
          <div className="w-8 h-8 bg-primary/10 rounded flex items-center justify-center shrink-0">
            <Mail size={14} className="text-primary" />
          </div>
          <div>
            <div className="text-xs text-muted-foreground">Email</div>
            <a href="mailto:info@suttonbuilders.co.uk" className="text-sm font-semibold text-foreground hover:text-primary transition-colors">
              info@suttonbuilders.co.uk
            </a>
          </div>
        </div>

        <div className="flex items-center gap-3">
          <div className="w-8 h-8 bg-primary/10 rounded flex items-center justify-center shrink-0">
            <Globe size={14} className="text-primary" />
          </div>
          <div>
            <div className="text-xs text-muted-foreground">Website</div>
            <a href="#" className="text-sm font-semibold text-primary hover:underline">
              suttonbuilders.co.uk
            </a>
          </div>
        </div>

        <div className="flex items-start gap-3">
          <div className="w-8 h-8 bg-primary/10 rounded flex items-center justify-center shrink-0 mt-0.5">
            <MapPin size={14} className="text-primary" />
          </div>
          <div>
            <div className="text-xs text-muted-foreground">Address</div>
            <address className="text-sm font-semibold text-foreground not-italic leading-relaxed">
              14 Industrial Estate Road<br />
              Bury St Edmunds<br />
              Suffolk, IP33 1AB
            </address>
          </div>
        </div>
      </div>
      <hr className="border-border my-4" />
      <div>
        <div className="text-xs text-muted-foreground mb-2 font-semibold">Follow on social media</div>
        <div className="flex gap-2">
          {[
            { icon: FacebookIcon, label: 'Facebook', href: '#' },
            { icon: TwitterIcon, label: 'Twitter / X', href: '#' },
            { icon: InstagramIcon, label: 'Instagram', href: '#' },
          ]?.map((social) => (
            <a
              key={`social-${social?.label}`}
              href={social?.href}
              aria-label={social?.label}
              className="w-9 h-9 bg-muted rounded flex items-center justify-center text-muted-foreground hover:bg-primary hover:text-primary-foreground transition-colors"
            >
              <social.icon size={16} />
            </a>
          ))}
        </div>
      </div>
      <div className="mt-4 pt-4 border-t border-border">
        <button className="btn-primary w-full justify-center text-sm">
          <Phone size={14} />
          Call Sutton Builders
        </button>
      </div>
    </div>
  );
}